<div class="flex-row align-items-center">
  <i class="{{ data.icon }} text-primary"></i>
  {{ data.message | translate }}
</div>
